export const permissionToShowRole = ['Super-Admin'];
export const permissionToGetRouteList = ['Super-Admin'];
